import { render, staticRenderFns } from "./actFemaleRules.vue?vue&type=template&id=fe4fb5a6&scoped=true"
import script from "./actFemaleRules.vue?vue&type=script&lang=js"
export * from "./actFemaleRules.vue?vue&type=script&lang=js"
import style0 from "./actFemaleRules.vue?vue&type=style&index=0&id=fe4fb5a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4fb5a6",
  null
  
)

export default component.exports